import { Link } from "react-router-dom";
import Federal from "../../assets/Federal.png"
export default function FdrlStateNoticeResolution() {
  return (
    <>
      {/* Spacer for sticky header */}
      <div /> {/* Header spacing style={{ height: 72 }}*/}

      {/* Hero Section */}
      <section className="py-5 bg-white position-relative overflow-hidden">
        <div className="container py-4" data-aos="fade-left">
          <div className="row align-items-center gx-5">
            <div className="col-lg-7">
              <h1
                className="fw-bold mb-3"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  color: "#2e3d9c",
                  fontSize: "2.3rem",
                  lineHeight: 1.15,
                }}
              >
                Federal & State <span style={{
                  background: "linear-gradient(90deg, #6B46C1, #D53F8C)",
                  color: "transparent",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text"
                }}>Notice Resolution</span>
              </h1>
              <p className="fs-5 text-secondary mb-1" style={{ maxWidth: 540 }}>
                Receiving a tax notice from the IRS or state authorities can be stressful and confusing. Let our experts handle all notices, discrepancies, and negotiations—so you can focus on what matters most.
              </p>
            </div>
            <div className="col-lg-5 text-center d-none d-lg-block" style={{ zIndex: 1 }} data-aos="fade-right">
              <img
                src={Federal}
                alt="Tax Notice Illustration"
                className="img-fluid rounded shadow"
                style={{ maxHeight: 280, objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
        {/* Decorative background circle */}
        {/* <div
          aria-hidden="true"
          className="position-absolute top-0 end-0 opacity-15"
          style={{ width: 130, height: 130, background: "linear-gradient(135deg, #6B46C1, #D53F8C)", borderRadius: "50%", filter: "blur(18px)" }}
        /> */}
      </section>

      {/* Common Types of Tax Notices */}
      <section className="py-5" style={{ background: "#f9fafe" }}>
        <div className="container">
          <h2 className="fw-bold gradient-notice mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
            Common Types of Tax Notices
          </h2>
          <div className="row g-4">
            {[
              {
                title: "IRS Notice of Underreporting",
                icon: "bi bi-exclamation-triangle",
                description: "The IRS believes you owe more taxes than what was reported on your return.",
                color: "#D53F8C",
              },
              {
                title: "IRS Audit Notification",
                icon: "bi bi-search",
                description: "A request to review your tax return for discrepancies or errors.",
                color: "#6B46C1",
              },
              {
                title: "Notice of Balance Due",
                icon: "bi bi-cash-coin",
                description: "Indicates that you owe additional taxes, penalties, and interest.",
                color: "#2e3d9c",
              },
              {
                title: "State Tax Liabilities",
                icon: "bi bi-file-earmark-bar-graph",
                description: "Notices from state tax agencies for unpaid taxes, penalties, or audits.",
                color: "#224eae"
              },
              {
                title: "Penalty Abatement Requests",
                icon: "bi bi-umbrella",
                description: "Requests to reduce or remove penalties related to your notice.",
                color: "#31926A"
              }
            ].map((item) => (
              <div className="col-md-4 col-lg-3" key={item.title}>
                <div className="card h-100 border-0 shadow-sm p-4 text-center rounded-4">
                  <span
                    className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-54"
                    style={{ background: "#f7f2fa", margin: "0 auto" }}
                  >
                    <i className={`${item.icon} fs-2`} style={{ color: item.color }}></i>
                  </span>
                  <h6 className="fw-semibold mb-2" style={{ color: item.color }}>{item.title}</h6>
                  <p className="small text-secondary mb-0">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How We Help Section */}
      <section style={{ background: "#fff" }} className="py-5">
        <div className="container">
          <h2 className="fw-bold mb-4 gradient-notice" style={{ fontFamily: "'Poppins', sans-serif" }}>
            How We Can Help with Federal and State Notices
          </h2>
          <div className="row g-4">
            {[
              {
                step: "Understand the Notice",
                icon: "bi bi-clipboard-data",
                text: "We carefully review your tax notice to determine the reason for the issue and its potential impact.",
                color: "#6B46C1"
              },
              {
                step: "Dispute or Appeal",
                icon: "bi bi-arrow-repeat",
                text: "We can assist you in disputing the tax liability or filing an appeal if the notice is based on inaccurate or incomplete information.",
                color: "#D53F8C"
              },
              {
                step: "Negotiating with Authorities",
                icon: "bi bi-people",
                text: "We work directly with the IRS or state agencies to resolve issues — including settlements and payment plans.",
                color: "#224eae",
              },
              {
                step: "Penalty Abatement",
                icon: "bi bi-shield-check",
                text: "If you qualify, we’ll assist you in requesting a reduction or removal of penalties related to the notice.",
                color: "#31926A"
              },
              {
                step: "Compliance & Filing",
                icon: "bi bi-journal-check",
                text: "We ensure your returns are compliant and help with filing amended returns if necessary.",
                color: "#2e3d9c"
              },
            ].map((item) => (
              <div className="col-md-6 col-lg-4" key={item.step}>
                <div className="card h-100 border-0 shadow p-4 text-center rounded-4">
                  <span
                    className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle icon-54"
                    style={{ background: "#f7f2fa", margin: "0 auto" }}
                  >
                    <i className={`${item.icon} fs-2`} style={{ color: item.color }}></i>
                  </span>
                  <h6 className="fw-semibold mb-2" style={{ color: item.color }}>{item.step}</h6>
                  <p className="small text-secondary mb-0">{item.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Informative Section & Call to Action */}
      <section className="py-5 text-center" style={{ background: "#f5f7fb" }}>
        <div className="container">
          <p className="fs-5 text-secondary mb-4" style={{ maxWidth: 650, margin: "0 auto" }}>
            If you've received a tax notice or believe you may be facing one, <b>contact us immediately</b>. Our team will work with you to resolve the issue, minimize your liabilities, and ensure compliance with federal and state tax laws.
          </p>
          <div className="d-flex justify-content-center mt-4">
            <Link
              to="/contact"
              className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
              style={{
                background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
                boxShadow: '0 4px 15px rgba(213,63,140,0.45)',
                transition: 'transform 0.3s, box-shadow 0.3s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(213,63,140,0.7)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(213,63,140,0.45)';
              }}
            >
              Resolve Your Notice Now
            </Link>
          </div>
        </div>
      </section>

      {/* Custom Gradient Heading Style */}
      <style>{`
        .gradient-notice {
          background: linear-gradient(90deg, #6B46C1, #D53F8C);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
        }
      `}</style>

      {/* Bootstrap Icons CDN (if not loaded globally) */}
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css" />

    </>
  );
}
